export default "__VITE_ASSET__CKwwLT42__"